import get from '../../../common/services/api/get';

/**
 * return all customer summaries
 * @returns [{id, label}]
 */
export default function getCustomerSummaries() {
    return get('/api/v1/customer_summaries');
}
